import { FormSchemaDto } from "@amzn/crowd-front-end-common-library";
import { FieldSchemaBase } from "@amzn/crowd-front-end-common-library/dist/src/forms/shared";

const newParentTeamId: FieldSchemaBase = {
  propertyName: "newParentTeamId",
  label: "New parent team",
  propertyType: "team",
  placeholder: "Search...",
  hidden: false,
  validationRules: {
    presence: {
      allowEmpty: false,
      message: "^Please select a valid parent team.",
    },
  },
};

export const moveTeamFormSchema: FormSchemaDto = {
  groups: [
    {
      groupLabel: "Parent team",
      groupId: "general-group",
      fieldDefinitions: [newParentTeamId],
    },
  ],
};

export default moveTeamFormSchema;
